<template>
	<div class="modal large-modal">
		<div class="inner">
			<h2>Waiver</h2>
			<div class="content" ref="waiver_content">
				<h1>{{ showWaiverDetail.description }}</h1>

				<div v-if="showWaiverDetail.minor" style="margin: 0 0 1em 0;">
					<h3>Minor Info</h3>
					{{ showWaiverDetail.minor_info.full_name }}<br>
					{{ showWaiverDetail.minor_info.address_1 }}<br>
					{{ showWaiverDetail.minor_info.city }} {{ showWaiverDetail.minor_info.state }} {{ showWaiverDetail.minor_info.zip_code }} {{ showWaiverDetail.minor_info.country }}<br>
					<label>Date of Birth</label> {{ $formatDate(showWaiverDetail.minor_info.birthdate) }}
				</div>

				<div style="margin: 0 0 1em 0;">
					<h3>{{ showWaiverDetail.minor ? 'Parent / Guardian' : 'Customer' }} Info</h3>
					<table style="width: 100%;">
						<tr>
							<td>
								{{ showWaiverDetail.contact_info.first_name }} {{ showWaiverDetail.contact_info.last_name }}<br>
								{{ showWaiverDetail.contact_info.address_1 }}<br>
								{{ showWaiverDetail.contact_info.city }} {{ showWaiverDetail.contact_info.state }} {{ showWaiverDetail.contact_info.zip_code }}<br>
							</td>
							<td>
								<label>Date of Birth</label> {{ $formatDate(showWaiverDetail.contact_info.birthdate) }}<br>
								<label>Phone</label> {{ showWaiverDetail.contact_info.phone_number }}<br>
								<label>Email</label> {{ showWaiverDetail.contact_info.email_address }}<br>
								<label>Drivers License / ID</label> {{ showWaiverDetail.contact_info.drivers_license_state }} {{ showWaiverDetail.contact_info.drivers_license_number }}
							</td>
						</tr>
					</table>
				</div>

				<div style="margin: 0 0 1em 0;">
					<h3>Emergency Contact</h3>
					{{ showWaiverDetail.emergency_contact_info.full_name }}<br>
					<label>Phone</label> {{ showWaiverDetail.emergency_contact_info.phone_number }}<br>
					<label>Relationship</label> {{ showWaiverDetail.emergency_contact_info.relationship }}
				</div>

				<div v-if="(showWaiverDetail.contact_info.authorized_name_1 && showWaiverDetail.contact_info.authorized_id_1) || (showWaiverDetail.contact_info.authorized_name_2 && showWaiverDetail.contact_info.authorized_id_2)">
					<h3>Other Authorized Adults</h3>
					<template v-if="showWaiverDetail.contact_info.authorized_name_1 && showWaiverDetail.contact_info.authorized_id_1">
						{{ showWaiverDetail.contact_info.authorized_name_1 }}<br>
						<label>Drivers License / ID</label> {{ showWaiverDetail.contact_info.authorized_id_1 }}<br>
					</template>
					<template v-if="showWaiverDetail.contact_info.authorized_name_2 && showWaiverDetail.contact_info.authorized_id_2">
						{{ showWaiverDetail.contact_info.authorized_name_2 }}<br>
						<label>Drivers License / ID</label> {{ showWaiverDetail.contact_info.authorized_id_2 }}
					</template>

				</div>

				<h3>Waiver</h3>
				<div v-html="showWaiverDetail.content"></div>
				<img v-if="showWaiverDetail.signature" :src="showWaiverDetail.signature" />
				<div v-else style="font-family:'Brush Script MT',cursive; font-size: 3em;">{{ showWaiverDetail.contact_info.first_name }} {{ showWaiverDetail.contact_info.last_name }}</div>
				<div><label>Date Signed</label> {{ $formatDate(showWaiverDetail.waiver_date) }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="$emit('close')">Cancel</div>
				<div class="button neutral spaced" @click="printWaiver()">Print</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'waiver-detail',
    props: {
        showWaiverDetail: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
		printWaiver() {
			let printWindow = window.open('', 'Print Waiver')
			printWindow.document.write(`
				<html>
					<head>
						<style>
							body { font-family: Arial, Helvetica, sans-serif; }
							img { max-width: 100%; height: auto; }
						</style>
					</head>
					<body>
						${this.$refs.waiver_content.innerHTML}
					</body>
				</html>
			`);
			printWindow.document.close();

			printWindow.onload = () => {
				setTimeout(() => {
					printWindow.print();
					printWindow.close();
				}, 500); 
			};
		}
	}
}
</script>
